import React, { useEffect } from "react";
import { TemplateWrapped } from "../../Layout";

const ContactUs = () => {
  return (
    <TemplateWrapped title="Contact Us" showTitle={false} headerButtons={<></>}>
      <iframe
        src="https://forms.monday.com/forms/embed/a619d5c848810fa3c77a4710d9037a27?r=use1"
        style={{
          border: "none",
          width: "100%",
          height: "calc(100vh - 80px)",
          display: "block",
        }}
      />
    </TemplateWrapped>
  );
};

export default ContactUs;
